import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import ASHLogo from '../../../assets/American_Specialty_Health_Logo_Dark.svg';
import FooterMenu from './FooterMenu';
import { FOOTER_ITEMS } from '../../../scripts/navigationItems';
import FooterLanguageLinks from './FooterLanguageLinks';

const copyright = `© ${new Date().getFullYear()} American Specialty Health Incorporated (ASH). All rights reserved.`;

const Footer = props => {
	const theme = useTheme();
	const { pathname } = useLocation();

	const navigationItems = [
		{
			key: 'terms-and-conditions',
			label: 'Terms & Conditions',
			path: FOOTER_ITEMS.terms,
			newTab: true,
			external: false,
		},
		{
			key: 'privacy-statement',
			label: 'Privacy Statement',
			path: FOOTER_ITEMS.privacy,
			newTab: true,
			external: false,
		},
		{
			key: 'contact-us',
			label: 'Contact Us',
			path: FOOTER_ITEMS.contactUs,
			newTab: false,
			external: true,
		},
	];

	return (
		<Box
			{...props}
			component='footer'
			sx={{
				backgroundColor: 'background.eveCustom.secondary',
				color: 'text.primary',
			}}
		>
			<Box sx={{ py: 2 }}>
				<Container maxWidth={pathname === '/' ? false : 'xl'}>
					<Grid
						py={3}
						container
						display='flex'
						justifyContent='space-between'
						rowSpacing={5}
					>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<Stack>
								<Typography
									mb={1.75}
									variant='body1'
									component='p'
								>
									A Product of
								</Typography>
								<Box>
									<img
										src={ASHLogo}
										alt='ASH Logo'
										height='30'
									/>
								</Box>
							</Stack>
						</Grid>
						<Grid
							item
							xs={12}
							md={7}
							lg={6}
							xl={5}
							justifyContent='flex-end'
							alignContent='center'
							flexWrap='wrap'
						>
							<FooterMenu menuItems={navigationItems} />
						</Grid>
					</Grid>
					<Divider
						sx={{
							my: 2,
						}}
						orientation='horizontal'
					/>
					<Stack direction='row'>
						<OpenInNewIcon
							sx={{
								fontSize: 16,
								top: '0.1rem',
								position: 'relative',
								color: theme.palette.action.active,
								mr: 1,
							}}
						/>
						<Typography
							variant='body2'
							component='div'
							color={theme.palette.action.active}
						>
							<Typography
								variant='inherit'
								color='inherit'
								component='p'
							>
								Clicking on these links will take you away from
								ASHLink.com. ASHlink is not responsible for any
								content or the privacy practices of external
								websites.
							</Typography>
							<Typography
								variant='inherit'
								color='inherit'
								component='p'
							>
								ASHLink is a subsidiary of American Specialty
								Health Incorporated. ASHLink complies with
								applicable Federal civil right laws and does not
								discriminate on the basis of race, color,
								national origin, age, disability, or sex.
								ASHLink and the ASHLink logo are trademarks of
								ASH. Other names and logos may be trademarks of
								their respective owners.
							</Typography>
							<Typography
								variant='inherit'
								color='inherit'
								component='p'
								sx={{ mt: 3 }}
							>
								For language services, please call the number on
								your member ID card and request an operator. For
								other language services:&nbsp;
								<FooterLanguageLinks />
							</Typography>
						</Typography>
					</Stack>
				</Container>
			</Box>
			<Box sx={{ backgroundColor: 'primary.dark' }} py={4} px={2}>
				<Container maxWidth='xl'>
					<Stack
						spacing={2}
						direction={{ xs: 'column', sm: 'row' }}
						justifyContent='center'
					>
						<Typography
							variant='body2'
							color='primary.contrastText'
							textAlign={{ xs: 'center' }}
						>
							{copyright}
						</Typography>
					</Stack>
				</Container>
			</Box>
		</Box>
	);
};

export default Footer;
